import { AuthPermission, PermissionScope } from '@bechtel/ht-types';
import { flatMap } from 'lodash';
import { useAppUser } from '../context';

export const useAppPermissions = () => {
  const { appUser } = useAppUser();
  const userpermissionScopes = flatMap(
    appUser?.permissionScopes,
    (permissionScope: PermissionScope) => permissionScope.permission
  );

  const hasPermission = (permission: keyof typeof AuthPermission) => {
    return userpermissionScopes.findIndex((userpermissionScope) => userpermissionScope?.name === permission) > -1;
  };

  return { hasPermission };
};
